import type {
  IQRScannerParams,
  IQRScannerViewModel,
} from "@/components/screens/Login/Types/LoginTypes";
import useQRScanner from "@/hooks/useQRScanner";
import { useCallback, useEffect, useRef } from "react";

const QRScannerViewModel = ({
  active,
  onDetected,
  onCancel,
}: IQRScannerParams): IQRScannerViewModel => {
  const { videoRef, canvasRef, status, errorMessage, stop } = useQRScanner({
    active,
    onDetected,
  });
  const closeRef = useRef<HTMLButtonElement | null>(null);

  const handleCancel = useCallback(() => {
    stop();
    onCancel();
  }, [stop, onCancel]);

  useEffect(() => {
    if (active) {
      closeRef.current?.focus();
    }
  }, [active]);

  useEffect(() => {
    if (!active) {
      return undefined;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        handleCancel();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [active, handleCancel]);

  return {
    videoRef,
    canvasRef,
    status,
    errorMessage,
    closeRef,
    onCancel: handleCancel,
    labels: {
      title: "Scan QR code",
      prompt: "Point at the QR code",
      closeAriaLabel: "Close QR scanner",
      requesting: "Requesting camera access…",
    },
  };
};

export default QRScannerViewModel;
